@import "tailwindcss";

@layer utilities {
  /* Clears the fixed AskDocket FAB (bottom-6 right-6 w-12 = ~72px from right) */
  .fab-clearance {
    padding-right: 5rem;
  }
}

@layer base {
  main a {
    text-decoration: underline;
    text-underline-offset: 3px;
    text-decoration-thickness: 1px;
  }
}

@theme {
  --color-brand-green: #2d6a4f;
  --color-brand-green-light: #40916c;
  --color-brand-green-dark: #1b4332;
  --color-brand-black: #1a1a1a;
  --color-sidebar-bg: #111827;
  --color-sidebar-text: #d1d5db;
  --color-sidebar-active: #2d6a4f;
}
